/**
 * useSEO — 轻量级 SEO hook（无额外依赖）
 * 动态更新 document.title + meta + OG + JSON-LD
 * 组件卸载时自动还原默认值
 */
import { useEffect } from "react";

const DEFAULT_TITLE = "BTF CANADA · 显密文教基金会";
const DEFAULT_DESC  =
  "Discover your Ba Zi energy blueprint. Personalized Chinese astrology reports, deity guidance, and divination — powered by AI.";

function setMeta(name, content, attr = "name") {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function removeJsonLd(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

function injectJsonLd(id, data) {
  removeJsonLd(id);
  const el = document.createElement("script");
  el.id = id;
  el.type = "application/ld+json";
  el.textContent = JSON.stringify(data);
  document.head.appendChild(el);
}

/**
 * @param {Object} opts
 * @param {string}  opts.title        — <title> 内容（必填）
 * @param {string}  opts.description  — meta description
 * @param {string}  [opts.canonical]  — 页面规范 URL
 * @param {string}  [opts.ogImage]    — Open Graph 图片 URL
 * @param {Object}  [opts.jsonLd]     — JSON-LD 结构化数据
 * @param {string}  [opts.jsonLdId]   — script 标签 id（默认 "ld-json-page"）
 */
export default function useSEO({ title, description, canonical, ogImage, jsonLd, jsonLdId = "ld-json-page" }) {
  useEffect(() => {
    // Title
    document.title = title;
    // Meta description
    setMeta("description", description);
    // OG tags
    setMeta("og:title",       title,       "property");
    setMeta("og:description", description, "property");
    setMeta("og:type",        "website",   "property");
    if (canonical) setMeta("og:url",   canonical, "property");
    if (ogImage)   setMeta("og:image", ogImage,   "property");
    // Canonical link
    if (canonical) {
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;
    }
    // JSON-LD
    if (jsonLd) injectJsonLd(jsonLdId, jsonLd);

    // Cleanup — restore defaults on unmount
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta("description", DEFAULT_DESC);
      setMeta("og:title",       DEFAULT_TITLE, "property");
      setMeta("og:description", DEFAULT_DESC,  "property");
      removeJsonLd(jsonLdId);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);
}
